var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vermittelt-counter__number"},[_c('animated-number',{attrs:{"value":_vm.animNumber,"round":"1","formatValue":_vm.formated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }